import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { compose, withProps } from 'recompose';

import setTimeplanUnit from './setTimeplanUnit';
import TimeInput from '../TimeInput';
import DropdownSelect from '../../../components/Form/DropdownSelect';
import * as styles from './timeplan.css';
import deleteTimeplanUnit from './deleteTimeplanUnit';
import { TimeplanUnitRecord } from '../../../entities/records';
import { ButtonSmall } from '../../Button';
import PaymentWarning from './TimeplanUnitPaymentWarning';
import InvoiceWarning from './TimeplanUnitInvoiceWarning';
import Warnings from './TimeplanUnitWarnings';
import { withTranslation } from 'react-i18next';

function TimeplanUnit({
  disabled,
  from,
  setFrom,
  to,
  setTo,
  hasPayment,
  hasInvoice,
  workType,
  setWorkType,
  workTypes,
  deleteTPU,
  showWarnings,
  overlaps,
  duplicates,
  timeplanUnit,
  absentReason,
  setAbsentReason,
  absentReasons,
}) {
  return (
    <div className={styles.timeplanUnit}>
      <PaymentWarning hasPayment={hasPayment} />
      <InvoiceWarning hasInvoice={hasInvoice} />
      <div className={styles.workTypeContainer}>
        <DropdownSelect
          disabled={disabled}
          className={styles.workTypeSelect}
          input={{
            value: workType,
            onChange: setWorkType,
            onBlur: setWorkType,
          }}
          options={workTypes}
        />
        {!disabled && (
          <ButtonSmall
            icon="trash"
            iconStyle="danger"
            className={styles.removeButton}
            onClick={deleteTPU}
          />
        )}
      </div>
      <div className={styles.timeplanUnitTimesContainer}>
        <div className={styles.timeplanUnitTime}>
          <TimeInput
            disabled={disabled}
            input={{
              name: 'timeInputFrom',
              value: from,
              onChange: setFrom,
              onBlur: setFrom,
            }}
            className={styles.timeInput}
            formControl={false}
          />
        </div>
        <div className={styles.timeplanUnitTime}>
          <TimeInput
            disabled={disabled}
            input={{
              name: 'timeInputTo',
              value: to,
              onChange: setTo,
              onBlur: setTo,
            }}
            className={styles.timeInput}
            formControl={false}
          />
        </div>
        <Warnings
          showWarnings={showWarnings}
          duplicates={duplicates}
          overlaps={overlaps}
          timeplanUnit={timeplanUnit}
        />
      </div>
      {absentReasons.size > 0 && (
        <div className={styles.workTypeContainer}>
          <DropdownSelect
            disabled={disabled}
            className={styles.absentReasonSelect}
            input={{
              value: absentReason,
              onChange: setAbsentReason,
            }}
            options={absentReasons}
          />
        </div>
      )}
    </div>
  );
}

TimeplanUnit.defaultProps = {
  showWarnings: true,
  overlaps: false,
  duplicates: false,
};

TimeplanUnit.propTypes = {
  disabled: PropTypes.bool.isRequired,
  hasPayment: PropTypes.bool.isRequired,
  hasInvoice: PropTypes.bool.isRequired,
  timeplanUnit: PropTypes.instanceOf(TimeplanUnitRecord).isRequired,
  overlaps: PropTypes.bool,
  duplicates: PropTypes.bool,
  workTypes: PropTypes.instanceOf(List).isRequired,
  absentReasons: PropTypes.instanceOf(List).isRequired,
  showWarnings: PropTypes.bool,
};

export default compose(
  withTranslation(),
  withProps(({ timeplanUnit }) => {
    const {
      workType,
      from,
      to,
      absentReason,
      payment,
      invoice,
      skipPayment,
      skipInvoice,
    } = timeplanUnit.toJS();
    return {
      workType,
      from,
      to,
      absentReason,
      hasPayment: !!payment || skipPayment,
      hasInvoice: !!invoice || skipInvoice,
    };
  }),
  withProps(({ timeplanUnit, onChangeTimeplanUnits, timeplanUnits, t }) => ({
    setFrom: from => onChangeTimeplanUnits(setTimeplanUnit, timeplanUnit, { from }),
    setTo: to => onChangeTimeplanUnits(setTimeplanUnit, timeplanUnit, { to }),
    setWorkType: workType => onChangeTimeplanUnits(setTimeplanUnit, timeplanUnit, { workType }),
    setAbsentReason: absentReason =>
      onChangeTimeplanUnits(setTimeplanUnit, timeplanUnit, { absentReason }),
    deleteTPU: () => {
      if (!confirm(t('Är du säkert på att du vill ta bort passet?'))) {
        return;
      }

      onChangeTimeplanUnits(deleteTimeplanUnit, timeplanUnit, timeplanUnits.size === 1);
    },
  })),
)(TimeplanUnit);
